import slugifyLib from 'slugify'

export const slugify = (str: string, opt: Record<string, any> = {}) => {
  return slugifyLib(str.replaceAll('/', '-'), {
    strict: true,
    lower: true,
    ...opt,
  })
}

export default {
  slugify,
}